import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class AlertaInconsistencias extends Component {
    render () {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="popover-alert margin-end">
                        <div className="popover top">
                            <div className="arrow"></div>
                            <h3 className="popover-title">Hay inconsistencias en la distribución de límites</h3>
                            <div className="popover-content">
                                <p>
                                    <span>Los límites de las cuentas y de las tarjetas presentan inconsistencias que debe resolver.</span>
                                </p>
                                <p>
                                    <span>Por favor corríjalos con la opción </span>
                                    <a>
                                        <span>Distribuir límites</span>
                                    </a>
                                    <span> antes de finalizar la solicitud.</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default AlertaInconsistencias